// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__W8yPb","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1NoSK"};